export default __webpack_public_path__ + "static/media/HelveticaNeueMedium.2226d4bf.woff2";